<ng-container *ngIf="mode === modes.DISPLAY || mode === modes.FEEDBACK">
	<span
		*ngFor="let reaction of uniqueReactions"
		tabindex="0"
		[attr.aria-label]="getTooltip(reaction)"
		(click)="toggleReaction($event, reaction.emoji)"
		[matTooltip]="getTooltip(reaction)"
		[matTooltipClass]="'tooltip-wrap'"
		[matTooltipPosition]="mode === modes.FEEDBACK ? 'below' : 'above'"
		[ngClass]="{'reacted': reaction.i_reacted}"
		class="grouped-emoji">
		<ng-container *ngIf="mode !== modes.FEEDBACK; else feedback">
			<span class="emoji" *ngFor="let variant of reaction.variants">{{variant.emoji}}</span>
		</ng-container>
		<ng-template #feedback>
			<span class="emoji">{{reaction.emoji}}</span>
		</ng-template>
		<span *ngIf="reaction.count > 0 && mode !== modes.FEEDBACK" class="count">{{reaction.count}}</span>
	</span>
</ng-container>
<button
	*ngIf="mode !== modes.FEEDBACK && !comment.was_ai_generated"
	class="btn-none emoji-btn"
	[attr.aria-label]="'feedback-panel-add-reaction' | translate"
	[matMenuTriggerFor]="emojiMenu"
	#emojiMenuTrigger="matMenuTrigger"
	(click)="focusSearchField($event)"
	[matTooltip]="'feedback-panel-add-reaction' | translate"
	[matTooltipPosition]="mode === modes.ADD ? 'below' : 'above'">
	<i class="ficon-smile-o"></i>
</button>
<mat-menu class="emoji-menu" #emojiMenu="matMenu" yPosition="above">
	<ng-template matMenuContent>
		<div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
			<emoji-mart
				cdkTrapFocus
				[darkMode]="false"
				[color]="'#00A39A'"
				[totalFrequentLines]="1"
				[isNative]="true"
				title=""
				emoji=""
				[autoFocus]="true"
				[useButton]="true"
				[emojisToShowFilter]="emojiFilter"
				(emojiClick)="addReaction($event)"
				(keydown)="handleKeyDownEmojiPopup($event)">
			</emoji-mart>
		</div>
	</ng-template>
</mat-menu>
